import { SubscriptionState } from '@acl-services/jwt-highbond-middleware';
import { defaultTimezone } from '@issuemanager/test/constants';

export const localSession = {
  org_id: '223',
  subdomain: 'tony',
  region_code: 'US',
  locale: 'en',
  timezone: defaultTimezone,
  timezone_offset: '00:00',
  allowed_ip: false,
  fy_end_month: 12,
  fy_end_day: 31,
  exp: 1691106582,
  name: 'local test',
  org_admin: true,
  email: 'local.test@example.com',
  uid: 'HwHk8f3NNDKAiLK-khCM',
  date_format: '%m/%d/%Y',
  bound_ip: '190.1.24.27',
  org_name: 'Stark Industries',
  org_locale: 'en',
  subscription_state: 'internal' as SubscriptionState,
  iat: 1691106282,
  user_type: 'admin',
  creates_role: 'reader',
  whitelist_ip: false,
};
